import { useEffect, useState } from 'react';
import Overview from './overview';
import { fetchAvicRequest } from '../../avicExtension/helpers';
import { fetchById } from '../../pirExtension/helpers';
import { fetchStockPriceById } from '../../stockPriceExtension/helpers';
import { AppLoader } from '../../../../components/common/loader';
import AvicTable from '../../avicExtension/table';
import PirTable from '../../pirExtension/table';
import StockPriceTable from '../../stockPriceExtension/table';
import styled from '@emotion/styled';

const StyledTableContainer = styled.div`
  margin-top: 16px;
`;

const Info = ({ requestType, erId }) => {
  const [loading, setLoading] = useState(false);
  const [info, setInfo] = useState([]);

  const fetch = async () => {
    try {
      setLoading(true);
      const data =
        requestType === 'AVIC'
          ? await fetchAvicRequest(erId)
          : requestType === 'PIR'
          ? await fetchById(erId)
          : await fetchStockPriceById(erId);
      setInfo(data);
    } catch (e) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetch();
  }, [erId]);

  return loading ? (
    <AppLoader center size='lg' />
  ) : (
    <>
      <Overview
        er_id={erId}
        sku={info?.[0]?.material || info?.[0]?.sku}
        sku_description={info?.[0]?.material_description || info?.[0]?.sku_description}
        sales_org={info?.[0]?.sales_org}
        country={info?.[0]?.country}
      />

      <StyledTableContainer>
        {requestType === 'AVIC' ? (
          <AvicTable channels={info} readOnly={true} loading={loading} />
        ) : requestType === 'PIR' ? (
          <PirTable pir={info} loading={loading} readOnly={true} />
        ) : requestType === 'SP' ? (
          <StockPriceTable plants={info} readOnly={true} loading={loading} />
        ) : null}
      </StyledTableContainer>
    </>
  );
};

export default Info;
